export const FILTERED_ERRORS = ["can't make withdraw: forbidden"];

export const STOP_WORDS = ['unauthorized', 'calculate'];
